import { requestApi } from '@app/api';
import { withDocument } from '@app/api/paths';

type Status = 'PENDING' | 'TASK_REQUESTED' | 'ON_PROCESSING' | 'CREATED';

export function downloadAttachments(payload: {
  workspaceId: string;
  type: 'REQUESTER' | 'SIGNER' | 'ALL';
  documentId: string;
}) {
  return requestApi<{ url: string | null; status: Status }>({
    url: withDocument(
      `/workspaces/${payload.workspaceId}/documents/${payload.documentId}/attachments/download`
    ),
    method: 'POST',
    credentials: true,
    data: { type: payload.type },
  }).then((response) => response.data);
}
